import { combineReducers } from 'redux';
import betListReducer from './betListSlice';
import resultReducer from './resultSlice';
import statementReducer from './statementSlice';
import notificationReducer from './notificationSlice';

const myAccountReducer = combineReducers({
  betList: betListReducer,
  result: resultReducer,
  statement: statementReducer,
  notification: notificationReducer,
});

export default myAccountReducer;

export * from './betListSlice';
export * from './resultSlice';
export * from './statementSlice';
export * from './notificationSlice';
